let Relationship = [
  {
    title: "Quisque sit amet enim nec magna tincidunt eleifend.",
  },
  {
    title: "Integer vehicula porta magna vitae cursus.",
  },
  {
    title: "Sed laoreet congue odio ac egestas.",
  },
  {
    title: " Duis neque lectu",
  },
];
export default Relationship;
